export function maskCrNumber(cr: string): string {
  if (cr.length < 5) return cr;
  return `${cr.slice(0, 2)}${'*'.repeat(5)}${cr.slice(-3)}`;
}

export function maskMobile(mobile: string): string {
  // +9665XXXXXXXX → +9665****XXXX
  if (mobile.length < 8) return mobile;
  return `${mobile.slice(0, 6)}****${mobile.slice(-4)}`;
}

export function maskNameEn(name: string): string {
  return name
    .split(' ')
    .map((word) => (word.length > 1 ? `${word[0]}${'*'.repeat(word.length - 1)}` : word))
    .join(' ');
}

export function maskNameAr(name: string): string {
  return name
    .split(' ')
    .map((word) => (word.length > 1 ? `${word[0]}${'*'.repeat(word.length - 1)}` : word))
    .join(' ');
}

export function maskIdNumber(id: string): string {
  if (id.length < 4) return id;
  return `${id.slice(0, 2)}${'*'.repeat(5)}${id.slice(-2)}`;
}

export function maskLandline(phone: string): string {
  if (phone.length < 8) return phone;
  const mid = Math.floor(phone.length / 2);
  return `${phone.slice(0, mid - 2)}****${phone.slice(mid + 2)}`;
}

export const HIDDEN_ADDRESS = '*** Address Hidden ***';
